import React from "react";
import GaugeChart from 'react-gauge-chart';

class BatterySoC extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            chartData: [],
            index: this.props.index,
        };
    }

    componentDidMount() {
        this.setState({isLoading: true});

        const fetchData = () => {
            fetch("https://gigastorageinterface.ew.r.appspot.com/rhinojson")
                .then((res) => res.json())
                .then(
                    (result) => {
                        var data_object = result[parseInt(this.state.index)];
                        var state_of_charge = parseFloat(data_object.state_of_charge)

                        this.setState({
                            isLoading: false,
                            stateOfCharge: state_of_charge,
                            command: data_object.command,
                            action: data_object.action,
                            asset_name: data_object.asset_name
                        });
                    }
                );
        };

        fetchData();
        setTimeout(() => {
            fetchData();
        }, 20000);
    }

    render() {
        if (this.state.isLoading) {
            return <div>Fetching data from API</div>
        }

        return <div><h4>State of Charge {this.state.asset_name}</h4>
            <GaugeChart id="gauge-chart-{this.state.asset_name}"
                colors={[
                    "#EA4228",
                    "#F5CD19",
                    "#5BE12C",
                    "#F5CD19",
                    "#EA4228"
                ]}
               percent={this.state.stateOfCharge}
               arcsLength={[0.075, 0.15, 0.55, 0.15, 0.075]}
               marginInPercent={0.05}
               cornerRadius={6}
               arcPadding={0.05}
               textColor={"#fff"}
               needleColor={"#464A4F"}
               needleBaseColor={"#464A4F"}
               animate={true}
               animDelay={500}
            />
            <p>{this.state.command}: {this.state.action}MW</p>
        </div>
    }
}

export default BatterySoC;

